import type { DateTime } from "luxon"
import { useEffect, useRef, useState } from "react"

import { useDateTime } from "../../modules/localization/useDateTime"

import { useInterval } from "./useInterval"

// Returns the current time and keeps it fresh: refreshes every `refreshIntervalMs`
// and also immediately when the tab becomes visible again.
export function useCurrentTime(refreshIntervalMs: number): DateTime {
    const dateTimeFactory = useDateTime()
    const dateTimeFactoryRef = useRef(dateTimeFactory)
    dateTimeFactoryRef.current = dateTimeFactory

    const [currentTime, setCurrentTime] = useState(() => dateTimeFactory.now())

    useInterval(() => setCurrentTime(dateTimeFactoryRef.current.now()), refreshIntervalMs)

    useEffect(() => {
        const refreshOnVisible = () => {
            if (!document.hidden) setCurrentTime(dateTimeFactoryRef.current.now())
        }
        document.addEventListener("visibilitychange", refreshOnVisible)
        return () => document.removeEventListener("visibilitychange", refreshOnVisible)
    }, [])

    return currentTime
}
